var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinSupplierSecondaryRestricted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6878_138785)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9493 10.1715C21.5114 11.7336 21.5114 14.2663 19.9493 15.8284L15.8284 19.9493C14.2663 21.5114 11.7336 21.5114 10.1715 19.9493L6.0506 15.8284C4.4885 14.2663 4.4885 11.7336 6.0506 10.1715L10.1715 6.0506C11.7336 4.4885 14.2663 4.4885 15.8284 6.0506L19.9493 10.1715Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5957 10.5251C20.9626 11.8919 20.9626 14.108 19.5957 15.4748L15.4748 19.5957C14.108 20.9626 11.8919 20.9626 10.5251 19.5957L6.40415 15.4748C5.03732 14.108 5.03731 11.8919 6.40415 10.5251L10.5251 6.40415C11.8919 5.03732 14.108 5.03731 15.4748 6.40415L19.5957 10.5251Z",
    stroke: "black",
    strokeOpacity: 0.2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2929 12.2929C16.6834 12.6834 16.6834 13.3166 16.2929 13.7071L13.7071 16.2929C13.3166 16.6834 12.6834 16.6834 12.2929 16.2929L9.70711 13.7071C9.31658 13.3166 9.31658 12.6834 9.70711 12.2929L12.2929 9.70711C12.6834 9.31658 13.3166 9.31658 13.7071 9.70711L16.2929 12.2929Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6878_138785",
    x: 0.879028,
    y: 0.879028,
    width: 24.2418,
    height: 24.2418,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.495833 0 0 0 0 0.495833 0 0 0 0 0.495833 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6878_138785"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6878_138785",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinSupplierSecondaryRestricted);
export default __webpack_public_path__ + "static/media/pinSupplierSecondaryRestricted.be32aa71.svg";
export { ForwardRef as ReactComponent };